import React from 'react'
// @ts-ignore
import s from './style.css'
import withStyles from 'isomorphic-style-loader/lib/withStyles';

class venn extends React.Component {

  render () {
    return <iframe frameBorder="0" style={{
      width: '100%',
      height: '100%'
    }} src="/venn"></iframe>
  }
}
export default withStyles(s)(venn);



// WEBPACK FOOTER //
// src/routes/customChart/venn/venn.js